
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("66gVT", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $471070215d1af1ba$export$2cd8252107eb640b; });
// ====================================================================================
// slider3.module
// ====================================================================================

var $jG4hL = parcelRequire("jG4hL");
parcelRequire("hvI5k");
const $471070215d1af1ba$export$2cd8252107eb640b = ()=>{
    /**
   * Slick dots navigation customization
   *
   * @param {jQueryHTMLElement} elem
   * @param {Number} width - the span width is normally of the same width as other dash-like buttons
   */ function prepareSliderDotDecor(elem, width) {
        elem.before(`<span style="width:${width}px;"></span>`);
    }
    /**
   * Method that reinitialized Slick slider
   *
   * NOTE method is invoked only for LTR sliders
   * to make proper left offset (considering Bootstrap ".container" baseline)
   *
   * @param {HTMLElement} elem
   * @param {Object} sliderOpts - Pass Slick options when needed (optional)
   */ function reinitSlider(elem, sliderOpts) {
        const slContainerSelector = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).closest("section").get(0).querySelector(".container") ? ".container" : ".container-fluid";
        const sliderContainer = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).closest(slContainerSelector);
        const wWidth = window.innerWidth;
        // If slides should be static
        if (elem.dataset.no_mobile) {
            // Remove Slick initialization and additives when data-no_mobile attribute is specified
            if (elem.dataset.no_mobile && window.innerWidth < 768) {
                if (elem.classList.contains("slick-initialized")) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).slick("unslick");
                    sliderContainer.removeAttr("style");
                }
                return;
            } else if (!elem.classList.contains("slick-initialized") && sliderOpts) {
                // Otherwise, initialize slider when screen size changed to tablet
                // Reinitialize Slick slider
                (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).on("init", function(event, slick) {
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(event.target).addClass("slider-initialized");
                });
                (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).slick(sliderOpts);
            }
        }
        // Fix Slick issue (remove unneeded nav. buttons)
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).children("button.slick-arrow").remove();
        if (wWidth > 575) {
            let pAddOffset = 0;
            if (elem.dataset.arrow_inset) {
                if (wWidth >= 991 && wWidth < 1400) pAddOffset = 45;
                else if (wWidth >= 1400) pAddOffset = 65;
            }
            let combinedOffset = 80 + pAddOffset;
            let sliderContainerOffset = (wWidth - sliderContainer.width()) / 2 - 80;
            if (sliderContainerOffset < 0) sliderContainerOffset = 0;
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(sliderContainer).css({
                "padding-left": combinedOffset + "px",
                "padding-right": combinedOffset + "px",
                "margin-left": sliderContainerOffset + "px",
                "margin-right": 0,
                "max-width": `calc(100% - ${sliderContainerOffset}px)`
            });
        } else sliderContainer.removeAttr("style");
    }
    /**
   * Slick slide change callback
   * (See events table in the docs https://github.com/kenwheeler/slick)
   *
   * @param ev - Slick event
   * @param slick
   * @param {Number} currentSlide - current (activated) slide
   */ function slideChangeHandler(ev, slick, currentSlide) {
        if (!slick.$dots) return;
        const liElem = slick.$dots.find("li:first button");
        const dotShift = liElem.width() * currentSlide;
        // Dots decorations
        if (!liElem.prev().length && currentSlide > 0) prepareSliderDotDecor(liElem, liElem.width());
        liElem.css("transform", "translateX(" + dotShift + "px)");
    }
    /**
   * Slick slider initialization
   *
   * @param {HTMLElement} container
   * @param {Object} opts - Pass Slick options when needed (optional)
   * with custom options
   */ function initSlider(container, opts) {
        const arrowsContainer = container.parents(".content-line");
        const arrows = [
            arrowsContainer.find('[data-js="slider-arrows-prev"]').html(),
            arrowsContainer.find('[data-js="slider-arrows-next"]').html()
        ];
        const fading = typeof opts.fading === "boolean" ? opts.fading : true;
        const slickOpts = {
            rows: 0,
            arrows: true,
            infinite: true,
            autoplaySpeed: 3000,
            fade: fading,
            cssEase: "linear"
        };
        if (arrows[0] && arrows[1]) {
            const htmlArrow = '<a class="arrow arrow--';
            if (opts.arrows) {
                slickOpts.prevArrow = `${htmlArrow}prev" href="#" title="Vorherige">${arrows[0].replace(/\s\s+/g, "")}</a>`;
                slickOpts.nextArrow = `${htmlArrow}next" href="#" title="N\xe4chste">${arrows[1].replace(/\s\s+/g, "")}</a>`;
            }
        }
        const optsCustom = opts || {};
        if (container.data("max_slides")) optsCustom.slidesToShow = container.data("max_slides");
        if (container.data("dots")) optsCustom.dots = true;
        if (container.data("arrow_inset")) optsCustom.responsive[0].settings.arrows = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(container).on("init", function(event, slick) {
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(event.target).addClass("slider-initialized");
        });
        container.slick(Object.assign(slickOpts, optsCustom));
    }
    /**
   * Sliders initialization, for blocks that should have left offset considering Bootstrap ".container" baseline
   * Invokes initSlider and reinitSlider methods above when needed
   *
   * @param {jQueryHTMLElement[]} ltrSliders - set of blocks that should be initialized with Slick.js as LTR sliders
   * @param {Object} ltrSliderOptions - Pass Slick options with custom options
   */ function initLTRSlider(ltrSliders, ltrSliderOptions) {
        let slPrevScreenWidth = window.innerWidth;
        ltrSliders.each(function(i, slider) {
            if (slider.dataset.no_mobile && window.innerWidth < 768) return;
            const ltrSliderSlides = slider.children.length;
            let options = Object.assign(ltrSliderOptions, {
                arrows: slider.dataset.no_arrows === "true" ? false : true
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(slider).attr("data-slides_per_row", ltrSliderSlides);
            reinitSlider(slider, options);
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(slider).on("afterChange", slideChangeHandler);
            if (!(slider.dataset.no_mobile && window.innerWidth < 768)) setTimeout(()=>{
                initSlider((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(slider), options);
            }, 350);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(window).resize(function(e) {
            if (!e.isTrigger) {
                clearTimeout(this._sltimer);
                this._sltimer = setTimeout(()=>{
                    // Prevent operation when resize is not useful (for Android browsers)
                    if (Math.abs(window.innerWidth - slPrevScreenWidth) > 99) {
                        slPrevScreenWidth = window.innerWidth;
                        ltrSliders.each(function(i, ltrSlider) {
                            let options = Object.assign(ltrSliderOptions, {
                                arrows: ltrSlider.dataset.no_arrows === "true" ? false : true
                            });
                            reinitSlider(ltrSlider, options);
                        });
                    }
                }, 400);
            }
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))('[data-js="slider-3"]').length > 0) (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))('[data-js="slider-3"]').each(function(i, slider) {
        initLTRSlider((0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(slider), {
            rows: 0,
            // slidesToShow per screen does not plays role here due to variableWidth option
            slidesToShow: 1,
            arrows: true,
            dots: true,
            speed: 500,
            fade: false,
            cssEase: "ease-in-out",
            autoplay: false,
            rtl: false,
            autoplaySpeed: 7500,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    });
};

});


//# sourceMappingURL=slider3.module.088deb49.js.map
